import React from "react";
import PropTypes from "prop-types";
import {
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement
} from "@stripe/react-stripe-js";

// components & styles
import FormInput from "core/FormInput";
import FormInputLayout from "./FormInputLayout";
import StripeFormInput from "./StripeFormInput";
import { stripeElementStyles } from "./styles";

// helpers
import { nameFieldValidation } from "./helpers";

const EmptyForm = ({ form, handleFormChange }) => (
    <FormInputLayout
        form={form}
        handleFormChange={handleFormChange}
        cardNumberField={
            <StripeFormInput
                forStripeElement
                label="Credit card number"
                value={form.cardNumber}
                handleFormChange={value =>
                    handleFormChange(value, "cardNumber")
                }
            >
                <CardNumberElement
                    options={{
                        placeholder: "Credit card number",
                        style: stripeElementStyles
                    }}
                />
            </StripeFormInput>
        }
        mmyyField={
            <StripeFormInput
                forStripeElement
                label="MM/YY"
                value={form.expiration}
                handleFormChange={value =>
                    handleFormChange(value, "expiration")
                }
            >
                <CardExpiryElement options={{ style: stripeElementStyles }} />
            </StripeFormInput>
        }
        cvcField={
            <StripeFormInput
                forStripeElement
                label="CVC"
                value={form.cvc}
                handleFormChange={value => handleFormChange(value, "cvc")}
            >
                <CardCvcElement options={{ style: stripeElementStyles }} />
            </StripeFormInput>
        }
        nameField={
            <FormInput
                data-testid="checkout-form-name-field"
                validation={nameFieldValidation}
                value={form.name}
                onChange={value => handleFormChange(value, "name")}
                placeholderText="Name on card"
                labelText="Name on card"
            />
        }
        postalField={
            <FormInput
                value={form.address_zip}
                onChange={value => handleFormChange(value, "address_zip")}
                placeholderText="Postal code"
                labelText="Postal code"
            />
        }
    />
);

EmptyForm.propTypes = {
    form: PropTypes.object.isRequired,
    handleFormChange: PropTypes.func.isRequired
};

export default EmptyForm;
